import React from "react";
import { Target, Eye, CheckCircle2 } from "lucide-react";

const MissionVision = () => {
  const missionData = [
    "Creating awareness of importance of agriculture among society",
    "Providing Nutrition rich food by advising farmers",
    "Providing viable solution to farmers",
    "Involving AI to Farming for Better Outcome",
    "Creating farmer consumer Relation",
    "Reducing cost by renting our own machineries",
    "Increasing income by selling the product to international market",
  ];

  const visionData = [
    "Creating jobs in rural areas and involving youngsters into agriculture",
    "Improve life standard for agriculture family",
    "Providing solution for manpower shortage",
    "Modern agriculture with innovative solutions",
    "Implementing new machineries in-house",
    "Made in Asia products",
    "Supply chain among international countries",
  ];

  const green = "#1a4d2e";
  const gold = "#cca32a";

  return (
    <section className="mv-section">
      <div className="mv-container">
        {/* Header */}
        <div className="mv-header">
          <h2>Mission & Vision</h2>
          <span />
        </div>

        <div className="mv-timeline-wrapper">
          {/* Center Line */}
          <div className="mv-center-line" />

          {/* Mission */}
          <div className="mv-row left">
            <div className="mv-dot green" />
            <div className="mv-card">
              <div className="mv-card-header">
                <Target size={34} color={gold} />
                <h3>Our Mission</h3>
              </div>

              <ul>
                {missionData.map((item, i) => (
                  <li key={i}>
                    <CheckCircle2 size={18} color={gold} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Vision */}
          <div className="mv-row right">
            <div className="mv-dot gold" />
            <div className="mv-card">
              <div className="mv-card-header">
                <Eye size={34} color={gold} />
                <h3>Our Vision</h3>
              </div>

              <ul>
                {visionData.map((item, i) => (
                  <li key={i}>
                    <CheckCircle2 size={18} color={green} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .mv-section {
          padding: 5rem 1.5rem;
          background: linear-gradient(180deg, #f9fafb, #ffffff);
        }

        .mv-container {
          max-width: 1200px;
          margin: auto;
        }

        .mv-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .mv-header h2 {
          font-size: 2.6rem;
          color: ${green};
          font-weight: 700;
        }

        .mv-header span {
          display: block;
          width: 90px;
          height: 4px;
          background: ${gold};
          margin: 1rem auto 0;
          border-radius: 6px;
        }

        /* TIMELINE */
        .mv-timeline-wrapper {
          position: relative;
          display: flex;
          flex-direction: column;
          gap: 5rem;
        }

        .mv-center-line {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 50%;
          width: 3px;
          background: linear-gradient(${green}, ${gold});
          transform: translateX(-50%);
        }

        .mv-row {
          display: flex;
          align-items: center;
          position: relative;
        }

        .mv-row.left {
          justify-content: flex-start;
        }

        .mv-row.right {
          justify-content: flex-end;
        }

        .mv-dot {
          position: absolute;
          left: 50%;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          transform: translateX(-50%);
          background: white;
          border: 4px solid;
          z-index: 2;
        }

        .mv-dot.green {
          border-color: ${green};
        }

        .mv-dot.gold {
          border-color: ${gold};
        }

        /* CARD */
        .mv-card {
          width: 46%;
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(12px);
          border-radius: 18px;
          padding: 2.5rem;
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(0, 0, 0, 0.06);
        }

        .mv-card-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1.8rem;
        }

        .mv-card-header h3 {
          font-size: 1.6rem;
          color: ${green};
          font-weight: 700;
        }

        .mv-card ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .mv-card li {
          display: flex;
          gap: 0.75rem;
          margin-bottom: 0.9rem;
          font-size: 1rem;
          color: #374151;
          line-height: 1.6;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .mv-center-line {
            display: none;
          }

          .mv-row {
            justify-content: center !important;
          }

          .mv-dot {
            display: none;
          }

          .mv-card {
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default MissionVision;
